const UserRouters = {
  login() {
    window.location.assign(`http://${window.location.host}/passport/login?refer=${encodeURI(window.location.href)}`);
  },
  toSiteList() {
    window.location.assign(`http://${window.location.host}/v3/site`)
  }
}

export default UserRouters;